<template>
  <fts-dropdown-select
    append-to-body
    :placement="placement"
    prevent-overflow-alt-axis
    prevent-overflow-tether-off
    append-toggle-class="activity-design-toggle"
    content-class="dropdown-menu dropdown-menu-w-xs"
    reference-id="fts-confirmation emoji-popper-dropdown-menu"
    overlay
    class="fts-activity-design-dropdown"
    @show="onShow"
    @hide="onHide"
  >
    <slot slot="toggle">
      <fts-label-group
        :item="activity"
        emoji
        :emoji-size="16"
        :label-color="activity.color"
      />
    </slot>
    <template #menu="{ select }">
      <div class="dropdown-form">
        <div class="dropdown-input-group">
          <fts-emoji
            append-to-body
            v-model="formData.emoji"
            :toggle-size="14"
          />
          <input
            class="fts-form-control"
            name="activity-name"
            v-model="formData.name"
            ref="designName"
            @input="$v.formData.$touch()"
          />
        </div>
        <div class="dropdown-form-error" v-if="$v.formData.name && $v.formData.name.$error">
          {{getActivityDesignError('name')}}
        </div>
      </div>
      <div class="dropdown-divider"></div>
      <div class="dropdown-option" @click="onDeleteFlow(select)" v-if="false">
        <div class="dropdown-option-icon">
          <font-awesome-icon :icon="['far', 'trash-can']" fixed-width />
        </div>
        <div>Delete flow</div>
      </div>
      <div class="dropdown-option" @click="onDelete(select)">
        <div class="dropdown-option-icon">
          <font-awesome-icon :icon="['far', 'trash-can']" fixed-width />
        </div>
        <div>Delete activity</div>
      </div>
    </template>
  </fts-dropdown-select>
</template>

<script>
import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import changesets from 'diff-json';

import validator from '../commons/designValidator';
import { store as canvasDesignStore } from '../store/canvasDesignStore';

import FTSDropdownSelect from '../elements/FTSDropdownSelect';
import FTSEmoji from '../elements/FTSEmoji';
import FTSLabelGroup from '../elements/FTSLabelGroup';

export default {
  components: {
    'fts-dropdown-select': FTSDropdownSelect,
    'fts-emoji': FTSEmoji,
    'fts-label-group': FTSLabelGroup
  },
  props: {
    activity: Object,
    activities: Array,
    fromStateId: String,
    toStateId: String,
    placement: String
  },
  data: () => ({
    formData: {},
    isDelete: false
  }),
  validations() {
    let formData = {};
    formData = validator.activityDesign(this.activities);
    return { formData };
  },
  methods: {
    onShow() {
      this.formData = _.cloneDeep(this.activity);
      this.$nextTick(() => {
        this.$refs.designName.focus();
      });
    },
    onHide() {
      if (!this.isDelete) {
        const diff = changesets.diff(this.formData, this.activity);
        if (!this.$v.formData.$invalid && diff.length) {
          this.$emit("activity:update", this.formData);
        }
      }
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    async onDeleteFlow(select) {
      const res = await this.$confirmation.show({
        type: "delete",
        title: "Flow"
      });

      if (res === true) {
        this.isDelete = true;
        this.$emit("flow:delete");
        select && select();
      }
    },
    async onDelete(select) {
      const res = await this.$confirmation.show({
        type: "delete",
        title: "Activity",
        text: this.formData.name,
        textEmoji: this.formData.emoji,
        textColor: this.formData.color
      });

      if (res === true) {
        this.isDelete = true;
        this.$emit("activity:delete");
        select && select();
      }
    },
    getActivityDesignError(key) {
      return validator.activityDesignError(this.$v.formData, key);
    }
  },
  computed: {
    getFlows() {
      return canvasDesignStore.getters.canvasFlows.filter((x) =>
        x.fromStateId === this.fromStateId &&
        x.toStateId === this.toStateId &&
        x.activityId === this.activity.id
      );
    }
  }
}
</script>

<style lang="scss">
.fts-activity-design-dropdown {
  .activity-design-toggle {
    border-bottom: 1px dotted var(--fts-border);
  }
}
</style>